<template>
  <div class="aixam">
    <img src="/assets/images/images/logo_blanc.png" />
    <div class="aixam__tv">TV</div>
  </div>
</template>

<script>
export default {
  name: "AixamTvComponent",
};
</script>

<style lang="scss" scoped></style>
